export default __webpack_public_path__ + "static/media/CSD.fce349c5.png";